/**
 * Nguồn duy nhất cho phần giải thích chỉ số.
 *
 * ⚠️ FAC-M18-UISPEC-001 §E.2: bảng 1 của SCR-M18-004 và chú thích rê chuột của SCR-M18-001
 *    phải lấy từ **cùng một nguồn dữ liệu**, không viết tay ở hai nơi. Hai nơi viết riêng thì
 *    sau vài lần sửa sẽ lệch nhau, và người dùng sẽ tin vào cái sai.
 *
 * Khi `GET /kpi/output/glossary` có thật, bản dưới đây chỉ còn là dự phòng lúc lỗi mạng.
 */

/** Bảng 1 — 11 chỉ số trên báo cáo M18. `tooltip` dùng luôn cho chú thích rê chuột (§H.3). */
export const OUTPUT_METRICS = [
    {
        key: 'output',
        label: 'Sản lượng',
        meaning: 'TỔNG số lần sản xuất đã hoàn thành trong khoảng lọc, đã tính cả các lần làm lại.',
        formula: 'Đếm theo đơn vị đếm của công đoạn.',
        tooltip: 'TỔNG số lần sản xuất đã hoàn thành trong khoảng lọc, đã tính cả các lần làm lại. Bấm để xem danh sách',
        clickable: true,
    },
    {
        key: 'countUnit',
        label: 'Đơn vị đếm',
        meaning: 'Con số ở cột Sản lượng đếm theo đơn vị này.',
        formula: 'Thuộc tính của công đoạn, khai ở Cấu hình chỉ số tiêu chuẩn.',
        tooltip: 'Con số ở cột Sản lượng đếm theo đơn vị này. Với In, Cắt, Khắc thì đếm theo SẢN PHẨM, không đếm theo dòng vật liệu',
        clickable: false,
    },
    {
        key: 'timeBasis',
        label: 'Cách tính giờ',
        meaning: 'Cách ra con số giờ, độc lập với đơn vị đếm.',
        formula: 'Theo sản phẩm = định mức nhân 1. Theo dữ liệu file in = cộng theo từng dòng vật liệu.',
        tooltip: 'Cách ra con số giờ, độc lập với đơn vị đếm. Theo sản phẩm = định mức nhân 1. Theo dữ liệu file in = cộng theo từng dòng vật liệu của sản phẩm',
        clickable: false,
    },
    {
        key: 'distinctUnits',
        label: 'Sản phẩm khác nhau',
        meaning: 'Số sản phẩm khác nhau. Ở công đoạn đếm theo đơn hàng thì đếm số đơn khác nhau.',
        formula: 'Đếm barcode khác nhau, hoặc đếm đơn khác nhau.',
        tooltip: 'Số sản phẩm khác nhau. Ở công đoạn đếm theo đơn hàng thì đếm số đơn khác nhau. Bấm để xem danh sách gộp',
        clickable: true,
    },
    {
        key: 'redoCount',
        label: 'Số lần làm lại',
        meaning: 'Số lần một sản phẩm phải làm lại tại công đoạn này. Càng thấp càng tốt.',
        formula: 'Sản lượng − Sản phẩm khác nhau.',
        tooltip: 'Sản lượng trừ Sản phẩm khác nhau. Là số lần một sản phẩm phải làm lại tại công đoạn này. Càng thấp càng tốt',
        direction: 'Càng thấp càng tốt',
        clickable: true,
    },
    {
        key: 'standardHours',
        label: 'Giờ định mức',
        meaning: 'Tính trên phần sản lượng đã quy đổi được, ở mức chuẩn 100%.',
        formula: 'Cộng giờ định mức của từng sản lượng. Không nhân thêm hệ số nào.',
        tooltip: 'Tính trên phần sản lượng đã quy đổi được, ở mức chuẩn 100%. Không nhân thêm hệ số nào. Ô này không bấm được vì không phải số đếm',
        clickable: false,
    },
    {
        key: 'notComputed',
        label: 'Chưa tính được giờ',
        meaning: 'Là MỘT PHẦN NẰM TRONG Sản lượng, không phải số cộng thêm.',
        formula: 'Hai số riêng: thiếu định mức (IE xử lý) và thiếu dữ liệu file in (Designer xử lý).',
        tooltip: 'Là MỘT PHẦN NẰM TRONG Sản lượng, không phải số cộng thêm. Hai số: thiếu định mức (IE xử lý) và thiếu dữ liệu file in (Designer xử lý). Bấm từng số để mở danh sách việc',
        clickable: true,
    },
    {
        key: 'hasStandard',
        label: 'Đã có định mức',
        meaning: 'Tỷ lệ sản lượng tra ra được định mức. Dưới 90% thì cảnh báo nhưng vẫn hiện số.',
        formula: '(Sản lượng − thiếu định mức) / Sản lượng.',
        tooltip: 'Đã có định mức = (Sản lượng − thiếu định mức) / Sản lượng. Dưới 90% thì cảnh báo nhưng vẫn hiện số',
        clickable: false,
    },
    {
        key: 'hasFileData',
        label: 'Đã có dữ liệu file in',
        meaning: 'Chỉ tính trên công đoạn tính giờ theo dữ liệu file in. Không áp dụng thì hiện dấu gạch.',
        formula: '(Sản lượng − thiếu dữ liệu file in) / Sản lượng của các công đoạn tính theo dữ liệu file in.',
        tooltip: 'Chỉ tính trên công đoạn tính giờ theo dữ liệu file in. Tài khoản không làm In, Cắt, Khắc thì hiện dấu gạch, không hiện 0% và cũng không 100%',
        clickable: false,
    },
    {
        key: 'suspectCount',
        label: 'Cần kiểm tra ghi nhận',
        meaning: 'Số barcode xuất hiện quá ngưỡng tại công đoạn này. Không làm đổi số liệu báo cáo.',
        formula: 'Đếm trên log của mọi tài khoản trong khoảng lọc.',
        tooltip: 'Số barcode xuất hiện quá 3 lần tại công đoạn này, đếm trên log của mọi tài khoản trong khoảng lọc. Con số này tăng khi lọc khoảng rộng hơn',
        clickable: true,
    },
    {
        key: 'droppedCount',
        label: 'Dòng bị loại',
        meaning: 'Dòng log không tra được barcode về sản phẩm, hoặc thuộc công đoạn ngoài 9 công đoạn.',
        formula: 'Đếm dòng log bị loại, tách theo lý do.',
        tooltip: 'Dòng log không tra được barcode về sản phẩm, hoặc thuộc công đoạn ngoài 9 công đoạn của dòng decor. Bấm để xem lý do chi tiết',
        clickable: true,
    },
]

/** Chú thích rê chuột theo tên cột — dẫn xuất từ OUTPUT_METRICS để không viết hai lần. */
/**
 * Tên ĐẦY ĐỦ của từng chỉ số, tra theo khoá.
 *
 * ⚠️ Tồn tại vì tiêu đề cột trên bảng đã rút ngắn để bảng bớt cuộn ngang ("Cần kiểm tra ghi nhận"
 *    → "Nghi ngờ"). Khi nhãn hiển thị là VIẾT TẮT thì tooltip phải mở đầu bằng tên đầy đủ, nếu
 *    không người dùng rê chuột lên "Nghi ngờ" và đọc một đoạn giải thích không nhắc lại nó đang
 *    nói về chỉ số nào — rồi mở màn "Giải thích chỉ số" thấy một cái tên thứ ba.
 *
 * Nguồn vẫn là `OUTPUT_METRICS`, không phải một bảng chép tay: đổi `label` ở trên là chỗ này theo.
 */
export const OUTPUT_LABELS = OUTPUT_METRICS.reduce((acc, metric) => {
    acc[metric.key] = metric.label

    return acc
}, {})

export const OUTPUT_TOOLTIPS = OUTPUT_METRICS.reduce((acc, metric) => {
    acc[metric.key] = metric.tooltip

    return acc
}, {
    /*
     * ---- Chín chỉ số hiệu suất, thêm ở FAC-26417 ----
     *
     * ⚠️ Nguồn DUY NHẤT là `GET control/output/glossary` của service (màn Giải thích chỉ số đọc
     *    thẳng từ đó). Mấy dòng dưới đây là bản NGẮN cho tooltip đầu cột — nếu hai bên nói khác
     *    nhau thì người dùng rê chuột thấy một nghĩa, mở màn giải thích thấy nghĩa khác.
     */
    actualHours:
        'Giờ công theo bảng chấm công tổng hợp của HR, cũng là giờ tính lương. ⚠️ KHÔNG phải giờ có mặt: bảng đó chặn ở 8 giờ/ngày và đã trừ sẵn nghỉ giữa ca, nên phần tăng ca không nằm trong con số này',
    allocatedHours:
        'Giờ làm của mỗi ngày chia cho các công đoạn người đó làm trong CHÍNH ngày đó, theo tỷ trọng giờ định mức',
    efficiency:
        'Giờ định mức làm ra ÷ giờ công theo bảng chấm công của HR. Mẫu số GỒM cả việc không có định mức, chờ hàng, họp đầu ca nên mức bình thường khoảng 85–90%, không phải 100%. ⚠️ Bảng HR chặn ở 8 giờ/ngày nên ngày tăng ca cho con số cao hơn thực tế',
    efficiencyPure:
        'Giống Hiệu suất nhưng KHÔNG cộng giờ định mức của các lần làm lại — chỉ tính lần ĐẦU TIÊN mà CHÍNH tài khoản đó chạm vào sản phẩm đó TẠI CÔNG ĐOẠN ĐÓ, đúng như cột Số lần làm lại đang đếm. Người sửa lại hàng của người khác vì vậy được tính là lần đầu, và cùng một sản phẩm đi qua hai công đoạn là hai lần đầu riêng. Mẫu số GIỮ NGUYÊN nên nó luôn ≤ Hiệu suất, và khoảng cách giữa hai con số chính là phần đã tiêu vào làm lại. Sản phẩm làm lần đầu TRƯỚC khoảng lọc thì lần trong khoảng vẫn tính là lần đầu. Công đoạn đếm theo ĐƠN gộp mỗi đơn thành một sản lượng cho mỗi người nên ở đó luôn bằng nhau. Dòng "thuần" chỉ hiện khi hai con số khác nhau',
    relativeIndex:
        'Hiệu suất tại công đoạn ÷ trung vị công đoạn đó trên TOÀN XƯỞNG. 1,00 = bằng mặt bằng. Chỉ tính cho tài khoản đủ giờ phân bổ tối thiểu',
    grade:
        'Bốn hạng A/B/C/D theo ngưỡng CẤU HÌNH — con số cụ thể ở chân bộ lọc, không chép vào đây vì PO chỉnh được mà không cần deploy. Chưa đủ giờ, đủ ngày, hoặc tính được giờ dưới mức tối thiểu thì BỎ TRỐNG kèm lý do — không phải hạng D',
    efficiencyTrend:
        'Hiệu suất của tài khoản theo TỪNG NGÀY trong khoảng đang lọc. Đường đứt quãng ở ngày không tính được hiệu suất — chưa nhập giờ, đã khai nghỉ, hoặc hôm đó không có sản lượng nào quy được về người. Trục dọc co theo chính đường đó, nên nó nói LÊN hay XUỐNG chứ không so cao thấp giữa hai người — cột Hiệu suất bên cạnh mới so được',
    efficiencySpread:
        'Khoảng hiệu suất của 80% tài khoản ở giữa (bỏ 10% cao nhất và 10% thấp nhất). Trải rộng nghĩa là cùng công đoạn mà người làm chênh nhau nhiều',
    belowThreshold:
        'Số tài khoản có hiệu suất dưới ngưỡng B, trên tổng số tài khoản đủ mẫu tại công đoạn. '
        + 'Đếm TRONG nhóm đang lọc; còn phân vị và chỉ số tương đối vẫn so với toàn xưởng',
    stageSignal:
        'Định mức lệch? — trung vị cả công đoạn nằm ngoài khoảng hợp lý, nhiều khả năng sai ở định mức '
        + 'chứ không ở người. Chênh lệch lớn — P90 chia P10 vượt ngưỡng, khoảng cách giữa người nhanh và '
        + 'người chậm bất thường. Khi cả hai cùng đúng thì báo "Định mức lệch?", vì đo bằng một thước đã '
        + 'sai thì mọi khoảng cách trên thước đều không tin được',

    actor: 'Tài khoản đăng nhập đã thực hiện thao tác. Hệ thống không quản lý họ tên nhân viên. Tài khoản đã nghỉ việc vẫn hiện đủ số liệu của kỳ đã lọc',
    stage: 'Một trong 9 công đoạn của dòng decor. Mỗi công đoạn ứng với đúng một mã thao tác trong log',
})

/** Bảng 3 — bấm vào số nào thì ra danh sách gì (§E.2). */
export const OUTPUT_CLICK_MAP = [
    {cell: 'Sản lượng', opens: 'Danh sách từng dòng sản lượng của tài khoản và công đoạn đó'},
    {cell: 'Sản phẩm khác nhau', opens: 'Danh sách gộp theo barcode — mỗi sản phẩm một dòng'},
    {cell: 'Số lần làm lại', opens: 'Danh sách chỉ gồm sản phẩm phải làm lại'},
    {cell: 'Cần kiểm tra ghi nhận', opens: 'Danh sách barcode vượt ngưỡng, để chuyển Dev kiểm tra'},
    {
        cell: 'Chưa tính được giờ — thiếu định mức',
        opens: 'Danh sách sản lượng thiếu định mức — việc của IE / Trưởng khu vực',
        tone: 'warning',
    },
    {
        cell: 'Chưa tính được giờ — thiếu dữ liệu file in',
        opens: 'Danh sách sản lượng thiếu dữ liệu file in — việc của Designer / File operator',
        tone: 'danger',
    },
    {cell: 'Giờ định mức', opens: 'Không bấm được — không phải số đếm'},
    {cell: 'Đã có ĐM · dữ liệu file in', opens: 'Không bấm được — không phải số đếm'},
]

/**
 * Hộp "Cách đọc số liệu" ở cuối SCR-M18-001. Luôn hiển thị, không thu gọn (UI-09).
 *
 * ⚠️ Là HÀM của ngưỡng, không phải mảng hằng. Khoảng "hợp lý" của trung vị
 *    (`rateSanityLow`/`rateSanityHigh`) nằm trong `pp_output_control_config` và PO chỉnh được —
 *    viết cứng "120%" ở đây là hộp giải thích dạy một ngưỡng, còn cột Tín hiệu ngay bên cạnh báo
 *    theo một ngưỡng khác (mặc định 130%). Một màn hình tự mâu thuẫn thì người dùng tin cái nào?
 */
export const outputReadingNotesOf = (thresholds) => {
    const sanity = (thresholds && thresholds.rateSanity) || {}
    const pct = (ratio, fallback) => (typeof ratio === 'number' ? `${Math.round(ratio * 100)}%` : fallback)

    return [
        'Sản lượng là con số tổng, Chưa tính được giờ là một phần nằm bên trong — không cộng hai cột.',
        'Ở In, Cắt, Khắc thì sản lượng đếm theo sản phẩm, còn giờ định mức cộng theo từng dòng vật liệu của sản phẩm đó — hai việc khác nhau.',
        'Giờ định mức tính ở mức chuẩn 100%, chưa gồm chuẩn bị máy, chờ vật liệu, chờ lô, họp đầu ca, vệ sinh, đào tạo.',
        'Đang tạm coi 1 người vận hành 1 máy.',
        'Giờ làm thực tế nay nhập ngay trong hệ thống (màn Giờ làm thực tế), và là mẫu số của mọi chỉ số hiệu suất — ngày nào chưa nhập thì ngày đó bị loại khỏi hiệu suất, còn sản lượng vẫn tính đủ.',
        /*
         * Năm câu dưới đây nói ra những điều KHÔNG đoán được từ màn hình, và mỗi câu thiếu đều đã
         * sinh ra một câu hỏi thật:
         *   · không biết 85–90% là bình thường thì 88% bị đọc thành "kém";
         *   · không biết ngày lẻ bị loại thì người lọc nửa ngày đi báo lỗi số liệu;
         *   · không biết giờ chia theo tỷ trọng thì cột giờ của dòng con trông như số bịa;
         *   · không biết mốc dữ liệu thì ô "—" của Hoàn thiện / Đóng gói bị báo là lỗi.
         */
        `Mức bình thường của một công đoạn đã có định mức là khoảng 85–90%. Trên ${pct(sanity.high, '130%')} hoặc dưới ${pct(sanity.low, '60%')} thường là định mức đặt sai chứ không phải người làm nhanh hay chậm.`,
        /*
         * Ô chọn ngày của màn này KHÔNG còn chọn giờ, nên đừng nêu ví dụ "08:00 → 12:00" — đó là
         * dạy một thao tác người dùng không tạo ra được nữa. Khoảng lẻ giờ chỉ còn tới từ link cũ
         * hoặc từ người gọi API thẳng.
         */
        'Chỉ những ngày nằm TRỌN trong khoảng lọc mới tính hiệu suất. Mở một link cũ có khoảng lẻ giờ thì hai ngày ở hai đầu hiện "—".',
        'Một người làm nhiều công đoạn trong một ngày thì giờ công của ngày đó được chia cho các công đoạn theo TỶ TRỌNG giờ định mức, không chia đều.',
        /*
         * Màn hình hiện "—" cho nhóm này, KHÔNG hiện "Không áp dụng" — chữ đó dành riêng cho tài
         * khoản hệ thống và cho Khắc. Nói sai chữ là người dùng đi tìm một ô không tồn tại.
         */
        'Hoàn thiện chỉ quy được sản lượng về người từ 26/09/2026, Đóng gói từ 01/10/2026 — trước các mốc đó hệ thống không ghi ai làm, nên hiệu suất hiện "—" chứ không phải bằng 0.',
        'Khắc không có hiệu suất cá nhân: công đoạn này gần như không phát sinh log thao tác (29 dòng tính tới 26/10/2026), không đủ để đo.',
    ]
}

/** Khối cảnh báo về trường `area` (§E.2) — IE cần biết Khắc dùng chung trường với In. */
export const OUTPUT_AREA_WARNING = 'Trường area không tự phân biệt In với Khắc: hai công đoạn dùng chung một giá trị diện tích lấy từ dữ liệu file in. Việc một dòng vật liệu sinh giờ ở công đoạn nào là do cấu hình quyết định. Vì vậy chỉ số của Khắc phải đặt sao cho rate_khắc × area_in = thời gian khắc thực tế. Vật liệu vừa in vừa khắc thì khai hai nhóm ở hai công đoạn, mỗi nhóm một chỉ số riêng.'

/** Khối "Dữ liệu file in nhận từ FFM" (§E.2 · M16 §3.1 của SCR-M16-004). */
export const FILE_DATA_PAYLOAD_SAMPLE = `"material_lines": [
  { "material_code": "0205", "area": 22, "cutting_length": 50 },
  { "material_code": "0103", "area": 10, "cutting_length": 30 }
]`

export const FILE_DATA_FIELDS = [
    {field: 'material_code', meaning: 'Mã vật liệu, khớp danh mục. Là CHUỖI — giữ nguyên số 0 đứng đầu', usedBy: 'Cả ba công đoạn'},
    {field: 'area', meaning: 'Diện tích hình in, cm²', usedBy: 'In · Khắc (dùng chung)'},
    {field: 'cutting_length', meaning: 'Chiều dài đường cắt, cm. Gửi cả khi bằng 0', usedBy: 'Cắt'},
]

/** Hai hộp thông tin cuối SCR-M18-004. */
export const OUTPUT_INFO_BOXES = [
    'Báo cáo chỉ hiển thị tài khoản đăng nhập, không có cột họ tên và không có cột khu vực, vì hệ thống không quản lý hồ sơ nhân sự. Tài khoản đã nghỉ việc vẫn hiện đủ số liệu của kỳ đã lọc — lọc theo trạng thái hiện tại của tài khoản sẽ làm số liệu kỳ cũ bị hụt khi chạy lại.',
    'Chức năng này độc lập với chức năng Ghi nhận công đoạn sản xuất. Hai chức năng không yêu cầu trùng số: báo cáo này quy đổi log thành sản lượng và giờ định mức theo cấu hình, còn chức năng kia ghi nhận thao tác thô.',
]

/** TAB-D của M17 — GL1: chỉ số kết quả (10 dòng). */
export const CAPACITY_RESULT_METRICS = [
    {label: 'Số lượt qua công đoạn', meaning: 'Số item hoặc số đơn phải đi qua công đoạn này', formula: 'Đếm theo đúng đơn vị đếm sản lượng của công đoạn'},
    {label: 'Giờ công theo định mức', meaning: 'Số giờ cần để làm hết lượng hàng theo đúng định mức', formula: 'Cộng giờ định mức ở cấp item rồi chia 3600'},
    {label: 'Giờ công đã tính làm lại', meaning: 'Giờ công sau khi cộng phần phải sản xuất lại', formula: 'Giờ công theo định mức × (1 + tỷ lệ làm lại)'},
    {label: 'Số máy cần', meaning: 'Số máy cần để làm hết lượng hàng trong khung thời gian mục tiêu', formula: 'Làm tròn lên của: giờ máy cần / giờ làm việc hữu ích của một máy'},
    {label: 'Số máy đang có', meaning: 'Số máy thực tế đang có, nhập tay và được lưu dùng chung', formula: 'Người dùng nhập'},
    {label: 'Số người quy đổi', meaning: 'Số người lý thuyết, có phần lẻ. 2,5 nghĩa là cần 2,5 người làm suốt khung thời gian mới xong', formula: 'Giờ công đã tính làm lại / giờ làm việc hữu ích của một người'},
    {label: 'Số người cần bố trí', meaning: 'Số người thực tế phải xếp vào công đoạn', formula: 'Làm tròn lên của Số người quy đổi, vì không có nửa người'},
    {label: 'Số người đang có', meaning: 'Số người thực tế đang có, nhập tay và được lưu dùng chung', formula: 'Người dùng nhập'},
    {label: 'Thiếu / thừa người', meaning: 'DƯƠNG LÀ THIẾU, âm là thừa', formula: 'Số người cần bố trí − Số người đang có', emphasis: 'Dương là thiếu'},
    {label: 'Mức tải hiện tại', meaning: 'LỚN HƠN 1 LÀ ĐANG QUÁ TẢI', formula: 'Số người quy đổi / Số người đang có', emphasis: 'Lớn hơn 1 là đang quá tải'},
]

/** GL2 — chỉ số chất lượng dữ liệu (2 dòng), kèm người đi xử lý. */
export const CAPACITY_DATA_METRICS = [
    {label: 'Đã có định mức', meaning: 'Tỷ lệ item tra ra được định mức cho vật liệu tương ứng', owner: 'IE / Trưởng khu vực — vào màn hình cấu hình định mức khai bổ sung'},
    {label: 'Đã có dữ liệu file in', meaning: 'Tỷ lệ item đã có diện tích in và đường cắt', owner: 'Designer / File operator — tạo file in cho item còn thiếu'},
]

/** GL3 — tham số tính toán (8 dòng). */
export const CAPACITY_PARAM_GLOSSARY = [
    {label: 'Nguồn lấy hàng', meaning: 'Lấy lượng hàng từ Thống kê theo thời gian hay từ Chưa phân lô'},
    {label: 'Nhóm thời gian cam kết', meaning: 'Lọc item theo số giờ cam kết còn lại: 1, 2, 3 hoặc hơn 3 ngày'},
    {label: 'Khung thời gian mục tiêu', meaning: 'Muốn làm xong lượng hàng này trong bao nhiêu ngày làm việc'},
    {label: 'Số ca / ngày', meaning: 'Số ca sản xuất trong một ngày, từ 1 đến 3'},
    {label: 'Giờ / ca', meaning: 'Số giờ có mặt tại xưởng của một ca'},
    {label: 'Tỷ lệ giờ làm việc hữu ích', meaning: 'Tỷ lệ giữa thời gian thực sự làm việc có định mức trên tổng thời gian có mặt tại xưởng. KHÔNG phải tỷ lệ trừ giờ nghỉ giải lao'},
    {label: 'Số người trên một máy', meaning: 'Một máy cần mấy người trông. 0,5 nghĩa là một người trông hai máy'},
    {label: 'Tỷ lệ làm lại', meaning: 'Phần trăm sản lượng phải sản xuất lại do lỗi. Một giá trị chung cho mọi công đoạn'},
]

/** TAB-E của M17 — 9 gạch đầu dòng "Cách đọc báo cáo". */
export const CAPACITY_READING_NOTES = [
    'Báo cáo tính ở cấp item: mỗi item có diện tích in và đường cắt riêng nên giờ công của hai item cùng SKU có thể khác nhau.',
    'Có hai loại thiếu dữ liệu và hai người xử lý khác nhau: thiếu định mức là việc của IE / Trưởng khu vực, thiếu dữ liệu file in là việc của Designer / File operator.',
    'Diện tích hoặc đường cắt bằng 0 là giá trị hợp lệ và cho 0 giây, không phải thiếu dữ liệu.',
    'Báo cáo tính trên tổng lượng hàng cần sản xuất, không trừ phần đã làm và không xét hàng đang làm dở.',
    'Dán label và Đóng thùng đếm theo đơn, không đếm theo item.',
    'Chụp ảnh sản phẩm chỉ tính trên phần hàng được yêu cầu chụp, không tính trên toàn bộ.',
    'Tỷ lệ làm lại là một giá trị chung cho mọi công đoạn. Đánh đổi kèm theo: công đoạn có tỷ lệ lỗi thật cao hơn sẽ bị tính thiếu, công đoạn thấp hơn bị tính thừa.',
    'Tổng số người là tổng của các số đã làm tròn từng công đoạn nên luôn lớn hơn hoặc bằng làm tròn của tổng số người quy đổi — không ghép được người lẻ giữa hai công đoạn.',
    'Không cộng giờ công của các công đoạn để suy ra thời gian hoàn thành: các công đoạn chạy song song, và công đoạn nghẽn mới là kết luận cần đọc.',
]
